import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ComplaintsSaga
 */

/**
 *
 * @param {complaints} payload complains data
 */
export function setComplaints(complaints, filters, navigate) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_DATA,
    payload: {
      complaints: complaints,
      filters: filters,
      navigate
    }
  });
}

/**
 *
 * @param {complaintId} payload string
 */
export function setSelectedComplaint(complaintId, navigate) {
  store.dispatch({
    type: actionTypes.SET_SELECTED_COMPLAINT,
    payload: {
      complaintId,
      navigate
    }
  });
}

/**
 *
 * @param {data} payload complains data
 */
export function updateComplaints(remarks, complaintId, locationId, proof) {
  store.dispatch({
    type: actionTypes.UPDATE_COMPLAINTS_DATA,
    payload: {
      remarks: remarks,
      complaintId: complaintId,
      locationId: locationId,
      proof: proof
    }
  });
}

/**
 *
 * @param {type} payload complains data
 */
export function fetchCompliantAssets() {
  store.dispatch({
    type: actionTypes.FETCH_COMPLAINTS_ASSETS
  });
}

/**
 *
 * @param {data} payload complains data
 */
export function fixComplaints(data) {
  store.dispatch({
    type: actionTypes.FIX_COMPLAINTS,
    payload: data
  });
}

export function complaintTakeover(complaintId, employeeData) {
  store.dispatch({
    type: actionTypes.COMPLAINT_TAKEOVER,
    payload: {
      complaintId: complaintId,
      employeeData: employeeData
    }
  });
}

export function setFilter(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_FILTER,
    payload: {
      data: data
    }
  });
}

export function setSearchKey(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_SEARCH_KEY,
    payload: {
      data: data
    }
  });
}

export function setSortBy(data) {
  store.dispatch({
    type: actionTypes.SET_COMPLAINTS_SORT,
    payload: {
      data: data
    }
  });
}

export function createComplaints(data) {
  store.dispatch({
    type: actionTypes.CREATE_COMPLAINTS,
    payload: {
      data: data
    }
  });
}
